import { render, staticRenderFns } from "./GroupHeadDetail.vue?vue&type=template&id=45fe9f6f&scoped=true&lang=true"
import script from "./GroupHeadDetail.vue?vue&type=script&lang=js"
export * from "./GroupHeadDetail.vue?vue&type=script&lang=js"
import style0 from "./GroupHeadDetail.vue?vue&type=style&index=0&id=45fe9f6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fe9f6f",
  null
  
)

export default component.exports